<template>
  <div class="general-frame">
    <div class="general-neick">
      <div class="general-search-bar">
        <span>公司名称</span>
        <el-input
          class="inputBoxStyle"
          v-model="companyName"
          placeholder="请输入公司名称"
          style="width:250px;margin:0px 10px;"
        ></el-input>
        <span>公司类型</span>
        <el-select
          class="inputBoxStyle"
          style="width: 100%;width:130px;margin:0px 10px"
          v-model="companyType"
        >
          <el-option label="管理公司" value="platform"></el-option>
          <el-option label="运营公司" value="operation"></el-option>
        </el-select>
        <span>公司状态</span>
        <el-select
          class="inputBoxStyle"
          style="width: 100%;width:100px;margin:0px 10px"
          v-model="companyStatus"
        >
          <el-option label="存续" value="1"></el-option>
          <el-option label="在业" value="2"></el-option>
          <el-option label="吊销" value="3"></el-option>
          <el-option label="停业" value="4"></el-option>
        </el-select>
        <el-button
          type="primary"
          class="elm-but"
          @click="popup = 1;popupName ='新增'"
          icon="el-icon-plus"
          v-if="global.power('operation/company.add') == true"
        >新增</el-button>
        <el-button type="primary" class="elm-but" icon="el-icon-search" @click="getList()">搜索</el-button>
        <el-button
          type="primary"
          class="elm-but"
          style="margin-left:15px"
          :loading="loading"
          @click="resetData()"
          icon="el-icon-refresh"
        >重置</el-button>
      </div>
      <div>
        <table class="surface">
          <thead>
            <tr>
              <th>公司编号</th>
              <th>公司名称</th>
              <th>公司编码</th>
              <th>公司类型</th>
              <th>公司状态</th>
              <th>公司负责人</th>
              <th>公司地址</th>
              <th style="width: 200px;">公司简介</th>
              <th>联系方式</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in  data" :key="index">
              <td>{{item.id}}</td>
              <td>{{item.companyName}}</td>
              <td>{{item.companyNo}}</td>
              <td>{{item.companyType == 1 ? "管理公司":"运营公司"}}</td>
              <td>{{getCompanyStatus(item.companyStatus)}}</td>
              <td>{{item.companyPrincipal}}</td>
              <td>{{item.companyAddress}}</td>
              <td style="line-height: 24px;padding: 14px;text-align: justify;" class="textTips">
                <span class="textHidden" style="width: 200px;">{{item.companyProfile}}</span>
                <div
                  style="text-align: right;margin-top:5px"
                  v-if="item.companyProfile.length > 40"
                >
                  <el-popover
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    :content="item.companyProfile"
                  >
                    <el-button slot="reference">查看全部</el-button>
                  </el-popover>
                </div>
              </td>
              <td>{{item.companyContacts}}</td>
              <td class="color_button" style="padding: 0px 10px;">
                <span
                  @click="edit(item)"
                  v-if="global.power('operation/company.update') == true"
                  class="margin-but"
                >
                  <i class="el-icon-edit"></i>编辑
                </span>

                <span
                  @click="deleteList(item.id)"
                  style="color:#f56c6c"
                  v-if="global.power('operation/company.cancel') == true"
                  class="margin-but"
                >
                  <i class="el-icon-delete"></i>删除
                </span>

                <router-link :to="{path:'/companyDetails', query:{ id:item.id}}">
                  <span>
                    <i class="el-icon-search"></i>查看人员
                  </span>
                </router-link>
              </td>
            </tr>
          </tbody>
          <noData :data="data" />
        </table>
        <el-pagination
          background
          style="text-align: center;margin-top:15px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum "
          layout="prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <!-- 新增编辑 -->
    <div class="window" v-show="popup == 1">
      <div style="width:60%;background:#FFF;border-radius: 4px;">
        <div class="window_top">
          <span>{{popupName}}</span>
          <i class="el-icon-close" @click="popup = 0;form.id = null;$refs.form.resetFields()"></i>
        </div>
        <div style="padding: 20px;">
          <el-form
            :label-position="'right'"
            label-width="100px"
            ref="form"
            :model="form"
            class="flex"
            :rules="formFules"
          >
            <div style="width:45%">
              <el-form-item
                label="公司名称"
                prop="companyName"
                :rules="[{ required: true, message: '请输入公司名称'}]"
              >
                <el-input placeholder="请输入公司名称" v-model="form.companyName" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item
                label="公司编码"
                prop="companyNo"
                :rules="[{ required: true, message: '请输入公司编码' }]"
              >
                <el-input placeholder="请输入公司编码" v-model="form.companyNo" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item
                label="公司类型"
                prop="companyType"
                :rules="[{ required: true, message: '请选择公司类型' }]"
              >
                <el-select v-model="form.companyType" style="width: 100%">
                  <el-option label="管理公司" value="platform"></el-option>
                  <el-option label="运营公司" value="operation"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="公司状态"
                prop="companyStatus"
                :rules="[{ required: true, message: '请选择公司状态' }]"
              >
                <el-select v-model="form.companyStatus" style="width: 100%">
                  <el-option label="存续" value="1"></el-option>
                  <el-option label="在业" value="2"></el-option>
                  <el-option label="吊销" value="3"></el-option>
                  <el-option label="停业" value="4"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="width:48%">
              <el-form-item label="公司地址" prop="companyAddress">
                <el-input placeholder="请输入公司地址" v-model="form.companyAddress"></el-input>
              </el-form-item>
              <el-form-item label="公司简介" prop="companyProfile">
                <el-input placeholder="请输入公司简介" v-model="form.companyProfile"></el-input>
              </el-form-item>
              <el-form-item
                label="负责人"
                prop="companyPrincipal"
                :rules="[{ required: true, message: '请输入负责人' }]"
              >
                <el-input placeholder="请输入负责人" v-model="form.companyPrincipal"></el-input>
              </el-form-item>
              <el-form-item
                label="联系方式"
                prop="companyContacts"
              >
                <el-input
                  placeholder="请输入联系方式"
                  v-model="form.companyContacts"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  maxlength="11"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="window_bottom">
          <el-button type="primary" @click="submit('form')">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import noData from "@/components/html/noData";
export default {
  name: "company",
  components: {
    noData,
  },
  data() {
    return {
      pageSize: 10, //每页10条
      pageNum: 1, //当前页码
      total: 0,
      startEndData: [], //创建时间
      companyStatus: null, //公司状态
      companyName: null, //公司名称
      companyType: null, //公司类型
      bTime: "",
      eTime: "",
      data: null,
      popup: 0,
      loading: false,
      popupName: "新增",
      form: {
        companyAddress: "",
        companyContacts: "",
        companyName: "",
        companyNo: "",
        companyPrincipal: "",
        companyProfile: "",
        companyStatus: "",
        companyType: null,
        createTime: null,
        id: null,
      },
      //日期之后禁止选中
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如
        },
      },
      formFules: {
        companyContacts: [
        {
            validator: function(rule, value, callback) {
              if (/^1[34578]\d{9}$/.test(value) == false && value != '') {
                callback(new Error("手机号格式错误"));
              } else {
                callback();
              }
            },
            trigger: "blur"
        }],
      },
    };
  },

  methods: {
    getList() {
      this.get("operation/operational/list", {
        companyName: this.companyName,
        companyType: this.companyType,
        companyStatus: this.companyStatus,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }).then((res) => {
        this.data = res.data.rows;
        this.total = res.data.total;
      });
    },

    //pageNum  改变时会触发
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList(); //调用终端数据接口
    },
    //pageSize改变时会触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },

    //重置
    resetData() {
      this.companyName = null;
      this.companyType = null;
      this.companyStatus = null;
      this.startEndData = null;
      this.bTime = null;
      this.eTime = null;
      this.form.id = null;
      this.getList();
    },

    //编辑
    edit(item) {
      this.popup = 1;
      this.popupName = "编辑";
      this.form.id = item.id;
      this.form.companyAddress = item.companyAddress;
      this.form.companyContacts = item.companyContacts;
      this.form.companyName = item.companyName;
      this.form.companyNo = item.companyNo;
      this.form.companyPrincipal = item.companyPrincipal;
      this.form.companyProfile = item.companyProfile;
      this.form.companyStatus = item.companyStatus.toString();
      this.form.companyType = item.companyType.toString();
      this.form.createTime = item.createTime;
    },

    //提交
    submit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.popupName === "编辑") {
            this.put("operation/operational", this.form).then((res) => {
              if (res.data.code == 200) {
                this.getList();
                this.form.id = null;
                this.popup = 0;
                this.$refs.form.resetFields();
                this.$message({
                  type: "success",
                  message: "修改成功!",
                });
              } else {
                this.$message.error(res.data.returnMsg);
              }
            });
          } else {
            var form = this.form;
            this.postNo("operation/operational", form).then((res) => {
              if (res.data.code == 200) {
                this.getList();
                this.popup = 0;
                this.form.id = null;
                this.$refs.form.resetFields();
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
              } else {
                this.$message.error(res.data.returnMsg);
              }
            });
          }
        }
      });
    },

    //删除账号
    deleteList(id) {
      this.$confirm("是否删除??", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteNo("operation/operational/" + id, {}).then((res) => {
            if (res.data.code == 200) {
              this.getList();
              this.$message({
                message: "删除成功!",
                type: "success",
              });
            } else {
              this.$message.error(res.data.returnMsg);
            }
          });
        })
        .catch(() => {});
    },

    //公司状态
    getCompanyStatus(val) {
      return val == 1
        ? "存续"
        : val == 2
        ? "在业"
        : val == 3
        ? "吊销"
        : val == 4
        ? "停业"
        : "";
    },
  },
  mounted() {
    this.getList();
  },
  created: function () {},
};
</script>

<style scoped>
.textTips /deep/ .el-button {
  padding: 4px 9px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu/maintenance/company.vue